import { render } from "./ProjectsSmallList.vue?vue&type=template&id=05b3a1fe&scoped=true"
const script = {}

import "./ProjectsSmallList.vue?vue&type=style&index=0&id=05b3a1fe&scoped=true&lang=css"

import exportComponent from "D:\\Projects For Fun\\PortfolioWebsite\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b3a1fe"]])

export default __exports__